import type { AxiosRequestConfig } from 'axios';

import { apiClient } from './client';

export function getMe (config?: AxiosRequestConfig) {
  return apiClient.get('/user/me', config);
}

export function invalidateToken () {
  return apiClient.post('/user/logout');
}

export function getSsoTokenUrl (): string {
  return `${import.meta.env.VITE_API}/api/authenticate/sso/token`;
}

export function getSsoLogoutUrl (redirectUrl: string): string {
  return `${import.meta.env.VITE_API}/api/authenticate/sso/logout?redirect=${redirectUrl}`;
}

export function getSsoLoginUrl (redirectUrl: string, organizationId: string): string {
  return `${import.meta.env.VITE_API}/api/authenticate/sso/login?redirect=${redirectUrl}&organization=${encodeURIComponent(organizationId)}`;
}
